<i18n lang="yaml">
zh:
  tool_title: "购买记录"

en:
  tool_title: "Order Records"
</i18n>
<template>
<div >
  <div style="padding: 1rem;background: #FAFAFD;transform: translate(0);padding-bottom: 0;">
    <div style="font-weight: 600;font-size: 20px;color: rgba(0,0,0,0.8);" class="d-flex">
        <div class="pointer" style="font-size: 16px;color: rgba(36,36,36,0.5);margin-right: 6px;" @click="$router.push('/home')">
          <img src="../../assets/icon-home.png" style="width: 40px;">
        </div>
        <div v-if="" style="align-items: center;display: flex;">
          {{ cozeBot.title }}
        </div>
    </div>
  </div>
  <div>
    <iframe style="width: 100%;height: 86vh;border: none;margin-top: -10px;"
        id="coze-iframe"
        :src="wrapBotPageUrl()"
        allow="clipboard-read; clipboard-write"
      ></iframe>
  </div>
</div>
</template>
<script>
import * as EnumApi from '@/api/enums'
import * as AccountApi from '@/api/account'
import { mapState, mapMutations} from 'vuex'
export default {
  name: 'Tools',
  components: {

  },
  data() {
    return {

    }
  },
  mounted(option) {
    // this.initChatBot()
  },
  computed: {
  	...mapState(['user', 'story', 'cozeBot'])
  },
  methods: {
    ...mapMutations(['setStory', 'setCozeBot', 'setShowDialogFlag']),
    wrapBotPageUrl(){
      return process.env.VUE_APP_INVITE_URL+'mali-bot.html?bot_id='+this.cozeBot.botId+'&app_id=113519709&user_id='+this.user.id+'&t='+Number(new Date())
    }
  }
}
</script>

<style scoped lang="scss">


</style>
